/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import Referral from './Referral/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Form/ReferralsSection/New/Confirm/Content"
  
}) {
  return (<React.Fragment
>
<Referral
  viewPath={`${viewPath}/Referral`}
/>
{children}
</React.Fragment>)
}